import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from "react-redux"
import Faqs from '../Faqs'
import HelpfulInformation  from '../HelpfulInformation'

import { Col } from '@amzn/stencil-react-components/layout'

import { logPageView } from '../../../utils/emfLogs'
import { Pages } from "../../../utils/loggerConstants"
import { pageLoadLogs } from "../../../utils/loggerUtils"
import siteContentService from '../../../services/SiteContent.service'

class MoreAboutStock extends Component {

  componentDidMount(){
    logPageView(Pages.FAQs);
    pageLoadLogs(Pages.FAQs, this.props.employee);
  }

  render() {
    return (
      <Col dataTestId="MoreAboutStock" gridGap="S400">
        <HelpfulInformation articles={this.props.articles}/>
        <Faqs faqs={this.props.faqs}/>
      </Col>
    );
    
  }
}

const mapState = state => ({
  articles: siteContentService.getHomepageArticles(state.static_content),
  faqs: state.static_content.helpful_information.faq,
  employee: state.employee
});

export default connect(mapState)(withTranslation('translationsV2')(MoreAboutStock));
